import React from 'react';
import { graphql } from 'gatsby';
import SpotlightTabs from './SpotlightTabs';
import { getSettingsClass } from '~/utils/helpers';

const SpotlightTabsBlock: React.FC<{ block: SpotlightTabsProps }> = ({
  block,
}) => {
  const settingsClass = getSettingsClass(block.settings);

  return (
    <div
      className={`block__spotlight_tabs flex h-fit w-full justify-center ${settingsClass}`}
    >
      <SpotlightTabs
        spotlight_tabs={block.spotlight_tabs}
        spotlight_style={block.spotlight_style}
      />
    </div>
  );
};

export default SpotlightTabsBlock;

export const SpotlightBadgeFragment = graphql`
  fragment SpotlightBadgeFragment on SpotlightBadge {
    text
    background_color
    text_color
  }
`;

export const SpotlightStyleFragment = graphql`
  fragment SpotlightStyleFragment on SpotlightStyle {
    background
    background_selected
    border
    border_selected
    border_radius
  }
`;

export const SpotlightTabsFragment = graphql`
  fragment SpotlightTabsFragment on SpotlightTab {
    spotlight_badge {
      ...SpotlightBadgeFragment
    }
    spotlight_title {
      ... on SimpleSpotlightTitle {
        _template
        text
        color
        size
      }
      ... on MultipartSpotlightTitle {
        _template
        leading_part
        supporting_text
        supporting_subtext
        color
        leading_size
        supporting_size
        subtext_size
      }
    }
    spotlight_text {
      text
      color
      size
    }
    spotlight_image {
      src
      alt
    }
  }
`;

export const SpotlightTabsBlockFragment = graphql`
  fragment SpotlightTabsBlockFragment on Block {
    _template
    settings {
      ...SettingsFragment
    }
    spotlight_tabs {
      ...SpotlightTabsFragment
    }
    spotlight_style {
      ...SpotlightStyleFragment
    }
  }
`;
